export const JUDGE_POLICY_OPTIONS = [
  { value: "semantic-preservation-v4", label: "V4 ambiguity and reference quality", disabled: false },
  { value: "semantic-preservation-v5", label: "V5 hardened error taxonomy", disabled: false },
  { value: "semantic-preservation-v6", label: "V6 numeric formatting", disabled: false },
  { value: "semantic-preservation-v7", label: "V7 approved-reference contract", disabled: false },
  { value: "semantic-preservation-v8", label: "V8 proof-carrying firewall", disabled: false },
  { value: "semantic-preservation-v9", label: "V9 legacy schema (Azure-incompatible)", disabled: true },
  { value: "semantic-preservation-v10", label: "V10 Azure-compatible proof contract", disabled: false },
  { value: "semantic-preservation-v11", label: "V11 context-free Tutor-utility contract", disabled: false },
] as const;

export const CALIBRATION_REQUIRED_POLICIES = new Set(
  JUDGE_POLICY_OPTIONS.map(({ value }) => value),
);

export const DEFAULT_JUDGE_POLICY_VERSION = "semantic-preservation-v10";
